// Phone <-> internal auth-email handle.
//
// PESO seekers often have no email, so they register and log in with just their
// phone number + password. Under the hood we use a deterministic login handle,
// "<normalized-digits>@phone.boholtrabaho.com", for Supabase email/password auth.
//
// IMPORTANT: this normalization MUST stay byte-for-byte identical to the backend
// `_normalize_phone_ph()` / `_phone_auth_email()` in server.py — otherwise a
// phone-only seeker's login handle won't match what was created at signup and they
// will be locked out.

export function normalizePhonePH(phone) {
  let d = String(phone || '').replace(/\D/g, '');
  if (!d) return '';
  if (d.startsWith('0')) d = '63' + d.slice(1);                 // 0917xxxxxxx -> 63917xxxxxxx
  else if (d.length === 10 && d.startsWith('9')) d = '63' + d;  // 917xxxxxxx  -> 63917xxxxxxx
  return d;                                                      // already 63xxxxxxxxxx -> unchanged
}

export function phoneToAuthEmail(phone) {
  const d = normalizePhonePH(phone);
  return d ? `${d}@phone.boholtrabaho.com` : '';
}

// True when the input is a phone number rather than an email (used by the login page
// to decide whether to convert the identifier to a phone login handle).
export function looksLikePhone(value) {
  const s = String(value || '').trim();
  if (!s || s.includes('@')) return false;
  return /\d/.test(s) && /^[\d\s()+-]+$/.test(s);
}
